export default __webpack_public_path__ + "banner-bg08d37b.png";